import { Input } from 'avo-ui'
import ModalForm from 'components/commons/modal-form'
import UploadImage from 'components/commons/upload-image'

export const FormProductNomination = ({
    show,
    onHideForm,
    dataProductNomination,
    isLoading,
    isDisabled,
    onChangeForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-fit'}
            show={show}
            onHide={onHideForm}
            title={`${!dataProductNomination?.id ? 'Create' : 'Update'} Product Nomination`}
            isLoading={isLoading}
            isDisabled={isDisabled}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div
                    className={`flex-1 flex-col ${(dataProductNomination?.image_url?.base64 || dataProductNomination?.image_url) && 'space-y-3'}`}
                >
                    <div className={'font-semibold text-blue-90 required'}>Gambar Produk</div>
                    <UploadImage
                        className={'w-fit'}
                        classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                        id={'image-product'}
                        value={dataProductNomination?.image_url?.base64 || dataProductNomination?.image_url}
                        onChange={(value) => onChangeForm({ name: 'image_url', value })}
                    />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama Produk</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama produk'}
                        value={dataProductNomination?.name}
                        onChange={onChangeForm}
                    />
                </div>
            </div>
        </ModalForm>
    )
}
